import { matchesEventTypeFilter } from './calendar-event-type';
import { useCalendarViews } from './calendar-queries';
import { getCalendarRange } from './calendar-range';
import { useEventCalendarViewState } from './calendar-state';
import { MeetingMinutesRow, toMeetingMinutesRows } from './meeting-minutes-list-utils';

// One source of truth for the rows the Meeting Minutes tab works with: the shared header's range,
// narrowed by the Client/Internal filter and fanned out to one row per note. Both the reading list
// and the header's MeetingMinutesListFilter counts derive from this, so the counts always match
// the cards on screen. `rows` is undefined only until the first load — keepPreviousData in
// useCalendarViews keeps the previous range's events while the next range fetches.
export const useMeetingMinutesTabRows = (
    anchorDate: Date,
): { rows: MeetingMinutesRow[] | undefined; fromDate: Date; toDate: Date } => {
    const { eventCalendarViewState } = useEventCalendarViewState();
    const { calendarView, eventTypeFilter } = eventCalendarViewState;
    const { fromDate, toDate } = getCalendarRange(anchorDate, calendarView);
    const calendarViews = useCalendarViews({ fromDate, toDate });
    const rows = calendarViews.data?.calendarEvents
        .filter((event) => matchesEventTypeFilter(event, eventTypeFilter))
        .flatMap(toMeetingMinutesRows);
    return { rows, fromDate, toDate };
};
